/**
 * A pilot's loadout for one mech: module ids and cosmetic choices (Phase 6). Ids travel on the
 * wire and in the database; both ends resolve them against the same catalog, so a stale client
 * fails loudly instead of drifting. The mech id is never inside: it is always known from context
 * (the hangar slot, the queue ticket, the seat). A null paint channel means the mech's stock
 * colour from its recipe.
 */
import { z } from 'zod';
const id = z.string().regex(/^[a-z][a-z0-9-]*$/);
/** Upper bounds on list lengths so a payload cannot balloon; the real slot counts are validated. */
export const LOADOUT_LIST_MAX = 8;
export const LoadoutCosmeticsSchema = z
    .object({
    primary: id.nullable(),
    secondary: id.nullable(),
    accent: id.nullable(),
    emissive: id.nullable(),
    decal: id.nullable(),
    /** Cosmetic part item ids (catalog `part` items fitting this mech). */
    parts: z.array(id).max(LOADOUT_LIST_MAX),
})
    .strict();
/** Weapon swaps (Phase 8): the primary slot may take one of the mech's alternates; null = stock. */
export const LoadoutWeaponsSchema = z.object({ primary: id.nullable() }).strict();
export const LoadoutSchema = z
    .object({
    modules: z.array(id).max(LOADOUT_LIST_MAX),
    cosmetics: LoadoutCosmeticsSchema,
    /** Defaults keep loadouts saved before Phase 8 valid. */
    weapons: LoadoutWeaponsSchema.default({ primary: null }),
})
    .strict();
export function defaultLoadout() {
    return {
        modules: [],
        weapons: { primary: null },
        cosmetics: {
            primary: null,
            secondary: null,
            accent: null,
            emissive: null,
            decal: null,
            parts: [],
        },
    };
}
//# sourceMappingURL=schemas.js.map